// extracted by mini-css-extract-plugin
module.exports = {"milestones":"Milestones_milestones__u9Xsj","row":"Milestones_row__hdZ7D","milestone":"Milestones_milestone__9RIwa"};